import Link from 'next/link'
import React from 'react'
import {
  BlogCategoriesItem,
  BlogCategoriesListContainer,
  BlogCategoriesListTitle,
  BlogCategoriesUl,
  BlogCategoryLink
} from './BlogCategoriesList.styles'

export const BlogCategoriesList = ({ categories }) => {
  return (
    <BlogCategoriesListContainer>
      <BlogCategoriesListTitle>Categories</BlogCategoriesListTitle>
      <BlogCategoriesUl>
        {categories.map(category => (
          <BlogCategoriesItem key={category.id}>
            <Link href={`/blog/category/${category.attributes.slug}`} passHref>
              <BlogCategoryLink>{category.attributes.title}</BlogCategoryLink>
            </Link>
          </BlogCategoriesItem>
        ))}
      </BlogCategoriesUl>
    </BlogCategoriesListContainer>
  )
}
